import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import './style.styl';

var Icon = function Icon(_ref) {
  var iconId = _ref.iconId,
      _ref$customClass = _ref.customClass,
      customClass = _ref$customClass === void 0 ? '' : _ref$customClass,
      props = _objectWithoutPropertiesLoose(_ref, ["iconId", "customClass"]);

  return /*#__PURE__*/React.createElement("svg", Object.assign({
    className: "icon " + iconId + " " + customClass
  }, props), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#" + iconId
  }));
};

export default Icon;